<ng-container>
  <form>
    <mat-form-field appearance="fill">
      <mat-label>{{'WINDOW|Dodatkowe notatki:' | translate}}</mat-label>
      <textarea filled [formControl]='notesForm' matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
    </mat-form-field>
    <label for='imageInput'>{{'WINDOW|Wyślij zdjęcia:' | translate}}</label>
    <input (change)="addFiles($event)" [formControl]='filesForm' id='imageInput' type='file' value="wyślij zdjęcia" />
  </form>

</ng-container>

<div>
  <div>
    @for (attachment of attachments; track attachment; let i = $index) {
      @if (!attachment.deleted) {
        <div>
          <a (click)="downloadFile(attachment)">{{attachment.name}}</a> <button (click)="removeFile(i)" mat-icon-button>
          <mat-icon>remove_circle</mat-icon>
        </button>
      </div>
    }
  }
</div>
</div>